export default "__VITE_ASSET__BRUX28LW__"